<template>
    <!-- TW Snippet Start v2.0+ -->
    <div class="relative bg-white overflow-hidden" :id="$props.id">
        <div class="max-w-7xl mx-auto">
            <div class="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
                <svg class="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2" fill="currentColor" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
                    <polygon points="50,0 100,0 50,100 0,100" />
                </svg>

                <div class="relative pt-6 px-4 sm:px-6 lg:px-8">
                    <nav class="relative flex items-center justify-between sm:h-10 lg:justify-start" aria-label="Global">
                        <div class="flex items-center grow shrink-0 lg:grow-0">
                            <div class="flex items-center justify-between w-full md:w-auto">
                                <a href="#">
                                    <span class="sr-only">DSchránka</span>

                                    <LogoImg class="w-16 lg:w-12 h-auto" />
                                </a>
                                <div class="-mr-2 flex items-center md:hidden">
                                    <button @click="menuShow = true" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" id="main-menu" aria-haspopup="true">
                                        <span class="sr-only">Zobrazit hlavní menu</span>
                                        <!-- Heroicon name: menu -->
                                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="hidden md:block md:ml-10 md:pr-4 md:space-x-8">
                            <a href="#product" v-scroll-to="'#product'" class="font-medium text-gray-500 hover:text-gray-900">Domů</a>

                            <a href="#features" v-scroll-to="'#features'" class="font-medium text-gray-500 hover:text-gray-900">Funkce</a>

                            <a href="#pricing" v-scroll-to="'#pricing'" class="font-medium text-gray-500 hover:text-gray-900">Ceník</a>

                            <a :href="route('faq')" class="font-medium text-gray-500 hover:text-gray-900">FAQ</a>

                            <a :href="route('app')" class="bg-indigo-100 nline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50">
                                Přihlášení
                            </a>

                        </div>
                    </nav>
                </div>

                <transition
                    enter-active-class="duration-150 ease-out"
                    enter-from-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="duration-100 ease-in"
                    leave-from-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                >
                    <div v-show="menuShow" id="heroMenu" class="opacity-0 scale-95 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
                        <div class="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
                            <div class="px-5 pt-4 flex items-center justify-between">
                                <div>
                                    <LogoImg class="w-8 h-auto sm:w-10" />
                                </div>
                                <div class="-mr-2">
                                    <button @click="menuShow = false" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                        <span class="sr-only">Zavřít menu</span>
                                        <!-- Heroicon name: x -->
                                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div role="menu" aria-orientation="vertical" aria-labelledby="main-menu">
                                <div class="px-2 pt-2 pb-3 space-y-1" role="none">
                                    <a href="#product" v-scroll-to="'#product'"  class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">Domů</a>

                                    <a href="#features" v-scroll-to="'#features'" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">Funkce</a>

                                    <a href="#pricing" v-scroll-to="'#pricing'"  class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">Ceník</a>

                                    <a :href="route('faq')"  class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">FAQ</a>

                                </div>
                                <div role="none">
                                    <a :href="route('app')" class="block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100" role="menuitem">
                                        Přihlášení
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <main class="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                    <div class="sm:text-center lg:text-left">
                        <h1 class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                            <span class="block xl:inline">Využijte svou datovku</span>
                            <span class="block text-indigo-600 xl:inline"> naplno!</span>
                        </h1>
                        <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                            Zamilujte si DSchránku - nového cloudového klienta pro manipulaci s datovými schránkami s neomezenou archivací <span class="font-bold">zdarma</span>!
                        </p>
                        <div class="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                            <div class="rounded-md shadow">
                                <a :href="route('register')" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10">
                                    Vytvořit účet
                                </a>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
        <div class="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
            <img class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full" src="/img/hero_photo.jfif" alt="">
        </div>
    </div>

</template>

<script>
import ResponsiveNavLink from "@/Jetstream/ResponsiveNavLink";
import NavLink from "@/Jetstream/NavLink";
import LogoImg from "../../Components/LogoImg";
export default {
    name: "Hero",
    components: {LogoImg, NavLink, ResponsiveNavLink},
    data() {
        return {
            menuShow: false,

        }
    }
}
</script>

<style scoped>

</style>
